/* unplugin-vue-components disabled */import { render } from "./mobile-header.vue?vue&type=template&id=073640e4&scoped=true&ts=true"
import script from "./mobile-header.vue?vue&type=script&lang=ts"
export * from "./mobile-header.vue?vue&type=script&lang=ts"

import "./mobile-header.vue?vue&type=style&index=0&id=073640e4&lang=less&scoped=true"
import "./mobile-header.vue?vue&type=style&index=1&id=073640e4&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-yunxiaobao-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073640e4"]])

export default __exports__